import { render, staticRenderFns } from "./FormPromotionPage.vue?vue&type=template&id=e6211ffe&scoped=true&"
import script from "./FormPromotionPage.vue?vue&type=script&lang=js&"
export * from "./FormPromotionPage.vue?vue&type=script&lang=js&"
import style0 from "./FormPromotionPage.vue?vue&type=style&index=0&id=e6211ffe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6211ffe",
  null
  
)

export default component.exports